module.exports = __webpack_public_path__ + "static/media/opti-free.06978995.jpg";